import React, {useEffect, useState} from "react";
import {
    Alert,
    Box,
    Button,
    CircularProgress, Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from "@mui/material";
import {useKeycloak} from "@react-keycloak/web";
import {ePismoClientInstance} from "../Service/EPismoClient";
interface GeneratedDocument {
    signature: string;
    receiverName: string;
    receiverAddress: string;
    inbox: boolean;
    emailFilled: boolean;
    sending: boolean;
    sent: boolean;
    sendingWithEmail: boolean;
}

export default function CreateDocumentStep3(props: {documents: GeneratedDocument[],
    onDocumentChange: (signature: string, newDoc: GeneratedDocument) => void
}) {

    const keycloak = useKeycloak();
    const [errorSent, setErrorSent] = useState(false)
    const [allSent, setAllSent] = useState(false)
    const [allSentByEmail, setAllSentByEmail] = useState(false)
    const [showInbox, setShowInbox] = useState(false)
    const [showEmail, setShowEmail] = useState(false)
    const [email, setEmail] = useState("")

    const documentsByInbox = (documents: GeneratedDocument[], inbox: boolean): GeneratedDocument[] => {
        return documents.filter(doc => doc.inbox === inbox);
    }
    
    const downloadFile = (signature : string) => {
        ePismoClientInstance.getFile('/v1/gui/documents/' + signature + "/pdf", keycloak)
            .then(response => {
                const href = URL.createObjectURL(response.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', signature + '.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
    }


    const send = (doc: GeneratedDocument) => {
        if(!doc.inbox && !doc.emailFilled && !doc.sendingWithEmail) {
            props.documents.forEach(d => {
                d.sendingWithEmail = false;
                props.onDocumentChange(d.signature, d);
            })
            doc.sendingWithEmail = true;
            props.onDocumentChange(doc.signature, doc);
            return;
        }
        doc.sending = true
        props.onDocumentChange(doc.signature, doc);
        let url = '/v1/gui/documents/' + doc.signature + '/email';
        if(!doc.inbox && !doc.emailFilled && doc.sendingWithEmail) {
            url += '?email=' + email
        }
        ePismoClientInstance.post(url, keycloak, null).then(resp => {
            let data = resp.data
            if(data.status === 'OK') {
                doc.sent = true
                props.onDocumentChange(doc.signature, doc);
            }
            doc.sending = false
            doc.sendingWithEmail = false
            setEmail("")
            props.onDocumentChange(doc.signature, doc);
        }).catch(e => setErrorSent(true))
    }

    function sendAll() {
        props.documents.forEach(doc => {
            if(!doc.sent && !doc.sending && doc.inbox) {
                send(doc)
            }
        })
    }

    function sendAllByEmail() {
        props.documents.forEach(doc => {
            if(!doc.sent && !doc.sending && !doc.inbox && !doc.sendingWithEmail) {
                send(doc)
            }
        })
    }

    useEffect(() => {
        const sentEmail = !props.documents.some(d => !d.sent && !d.inbox);
        const sentInbox = !props.documents.some(d => !d.sent && d.inbox);
        setAllSent(sentInbox);
        setAllSentByEmail(sentEmail);
        setShowEmail(props.documents.some(d => !d.inbox))
        setShowInbox(props.documents.some(d => d.inbox))
    }, [props.documents]);
    
    

    return (
        <Box className="Step3">
            <Typography align="left" variant="h1"><span>3/3</span> Sukces</Typography>
            <Box className="SignatureWrapper">
                <Typography variant="h5">Wygenerowane pisma</Typography>
                {showInbox &&
                <>
                    <Typography variant="h6">Wiadomości do wysłania na skrzynkę odbiorczą({documentsByInbox(props.documents, true).length}):</Typography>
                    <TableContainer component={Paper}
                                    sx={{
                                        maxHeight: 230,
                                        mb:1
                                    }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{width: "20%"}}>Nr sygnatury pisma</TableCell>
                                    <TableCell sx={{width: "50%"}}>Odbiorca</TableCell>
                                    <TableCell sx={{width: "30%"}}>Akcje</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {documentsByInbox(props.documents, true).map((doc, index) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{pt: 0}}>{doc.signature}</TableCell>
                                        <TableCell sx={{pt: 0}}>{doc.receiverName}<br/>{doc.receiverAddress}</TableCell>
                                        <TableCell sx={{pt: 1, pb: 1}}>
                                            <Button variant="contained" size="small" onClick={e => send(doc)}
                                                    disabled={doc.sending || doc.sent}
                                                    sx={{mr: 1}}>
                                                {!doc.sent && !doc.sending && <>Wyślij {doc.sending && <CircularProgress size={20} sx={{ml: 1}}/>}</>}
                                                {doc.sent && <>Wysłano</>}
                                                {!doc.sent && doc.sending && <>Wysyłanie...</>}
                                            </Button>
                                            <Button variant="contained" size="small" onClick={() => downloadFile(doc.signature)}>
                                                Pobierz
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{display: 'flex', justifyContent: 'flex-end', pr: 6}}>
                        <Button variant="contained" size="medium" onClick={sendAll}
                                disabled={allSent}
                                sx={{mr: 1, mb:3}}>
                            {allSent && <>Wysłano wszystkie</>}
                            {!allSent && <>Wyślij wszystkie</>}

                        </Button>
                    </Box>
                </>}
                {showEmail && <>
                    <Typography variant="h6">Wiadomości do wysłania adresem email({documentsByInbox(props.documents, false).length}):</Typography>
                    <TableContainer component={Paper}
                                    sx={{
                                        maxHeight: 230,
                                    }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{width: "20%"}}>Nr sygnatury pisma</TableCell>
                                    <TableCell sx={{width: "50%"}}>Odbiorca</TableCell>
                                    <TableCell sx={{width: "30%"}}>Akcje</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {documentsByInbox(props.documents, false).map((doc, index) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{pt: 0}}>{doc.signature}</TableCell>
                                        <TableCell sx={{pt: 0}}>{doc.receiverName}<br/>{doc.receiverAddress}</TableCell>
                                        <TableCell sx={{pt: 1, pb: 1}}>
                                            {doc.sendingWithEmail && <TextField size="small" fullWidth label={"Aby wysłać, wprowadź adres e-mail"} variant="outlined" onChange={e => setEmail(e.target.value)} onBlur={e => setEmail(e.target.value)} value={email} sx={{mb: 2}}/>}
                                            <Button variant="contained" size="small" onClick={e => send(doc)}
                                                    disabled={doc.sending || doc.sent}
                                                    sx={{mr: 1, mb:2}}>
                                                {!doc.sent && !doc.sending && <>Wyślij {doc.sending && <CircularProgress size={20} sx={{ml: 1}}/>}</>}
                                                {doc.sent && <>Wysłano</>}
                                                {!doc.sent && doc.sending && <>Wysyłanie...</>}                                            </Button>
                                            <Button sx={{ mb:2}} variant="contained" size="small" onClick={() => downloadFile(doc.signature)}>
                                                Pobierz
                                            </Button>

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{display: 'flex', justifyContent: 'flex-end', pr: 6}}>
                        <Button variant="contained" size="medium" onClick={sendAllByEmail}
                                disabled={allSentByEmail}
                                sx={{mr: 1, mb:3}}>
                            {allSentByEmail && <>Wysłano wszystkie</>}
                            {!allSentByEmail && <>Wyślij wszystkie</>}

                        </Button>
                    </Box>
                </>}
                <Typography>Zawsze możesz wrócić do dokumentu. Podpisany plik znajduje się w zakładce Pisma. Będzie można go pobrać przez najbliższe 7 dni.</Typography>
            </Box>
        </Box>
    )
}